const VERSION = '1.0.2'

export default VERSION